import React from "react";
import { FiSend } from "react-icons/fi";
import { Loader2 } from "lucide-react";
import Button from "../../components/Button";

const ContactForm = ({
  formData,
  errors,
  status,
  loading,
  handleChange,
  handleSubmit,
}) => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl font-inter font-extrabold text-[#222222] uppercase">
          Send Us a <span className="text-[#7D192A]">Message</span>
        </h2>
        <p className="text-gray-600 font-inter mt-2">
          Fill out the form below and our team will get back to you within 24
          hours.
        </p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="space-y-6 surface-card p-8 md:p-10 rounded-2xl shadow-soft"
      >
        <div className="space-y-2">
          <label className="text-sm font-inter font-bold text-[#222222] uppercase tracking-wider ml-1">
            Full Name
          </label>
          <input
            required
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            autoComplete="name"
            maxLength={100}
            minLength={2}
            inputMode="text"
            aria-invalid={Boolean(errors.name)}
            className={`w-full px-5 py-4 rounded-xl border bg-[#ffffff] focus:border-[#F4B400] focus:ring-2 focus:ring-[#F4B400]/20 outline-none transition-all font-inter ${
              errors.name
                ? "border-red-400 focus:ring-red-200"
                : "border-gray-200"
            }`}
          />
          {errors.name && (
            <p className="text-xs font-inter text-red-600">{errors.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-inter font-bold text-[#222222] uppercase tracking-wider ml-1">
            Phone Number
          </label>
          <input
            required
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter your phone number"
            autoComplete="tel"
            inputMode="tel"
            maxLength={25}
            aria-invalid={Boolean(errors.phone)}
            className={`w-full px-5 py-4 rounded-xl border bg-[#ffffff] focus:border-[#F4B400] focus:ring-2 focus:ring-[#F4B400]/20 outline-none transition-all font-inter ${
              errors.phone
                ? "border-red-400 focus:ring-red-200"
                : "border-gray-200"
            }`}
          />
          {errors.phone && (
            <p className="text-xs font-inter text-red-600">{errors.phone}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-inter font-bold text-[#222222] uppercase tracking-wider ml-1">
            Email Address
          </label>
          <input
            required
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            autoComplete="email"
            inputMode="email"
            maxLength={254}
            aria-invalid={Boolean(errors.email)}
            className={`w-full px-5 py-4 rounded-xl border bg-[#ffffff] focus:border-[#F4B400] focus:ring-2 focus:ring-[#F4B400]/20 outline-none transition-all font-inter ${
              errors.email
                ? "border-red-400 focus:ring-red-200"
                : "border-gray-200"
            }`}
          />
          {errors.email && (
            <p className="text-xs font-inter text-red-600">{errors.email}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-inter font-bold text-[#222222] uppercase tracking-wider ml-1">
            Your Message
          </label>
          <textarea
            required
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            placeholder="How can we help you?"
            minLength={10}
            maxLength={2000}
            aria-invalid={Boolean(errors.message)}
            className={`w-full px-5 py-4 rounded-xl border bg-[#ffffff] focus:border-[#F4B400] focus:ring-2 focus:ring-[#F4B400]/20 outline-none transition-all font-inter resize-none ${
              errors.message
                ? "border-red-400 focus:ring-red-200"
                : "border-gray-200"
            }`}
          ></textarea>
          <div className="flex items-center justify-between gap-3">
            {errors.message ? (
              <p className="text-xs font-inter text-red-600">{errors.message}</p>
            ) : (
              <span className="text-[11px] font-inter text-gray-600">
                Minimum 10 characters.
              </span>
            )}
            <span className="text-[11px] font-inter text-gray-600">
              {formData.message.length}/2000
            </span>          </div>
        </div>

        {status.message && (
          <div
            className={`p-4 rounded-lg font-inter text-sm ${
              status.type === "success"
                ? "bg-green-100 text-green-700 border border-green-200"
                : "bg-red-100 text-red-700 border border-red-200"
            }`}
          >
            {status.message}
          </div>
        )}

        <Button
          type="submit"
          pill
          fullWidth
          className="py-4 font-black uppercase tracking-widest"
          disabled={loading}
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <Loader2 className="animate-spin" size={18} />
              SENDING...
            </span>
          ) : (
            <span className="flex items-center justify-center gap-2">
              SEND MESSAGE <FiSend size={18} />
            </span>
          )}
        </Button>
      </form>
    </div>
  );
};

export default ContactForm;
